class StorageService {
    public get<T>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            if (value === null) return null;

            return JSON.parse(value) as T;
        } catch (error) {
            console.error(`StorageService.get error for key "${key}":`, error);
            return null;
        }
    }

    public set<T>(key: string, value: T): void {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error(`StorageService.set error for key "${key}":`, error);
        }
    }

    public remove(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`StorageService.remove error for key "${key}":`, error);
        }
    }
}

export const storageService = new StorageService();